<script>
import Container from "%/dynamic-component-editor/standard-elements/layouts/Container.vue";
import DynamicElementWithContext from "%/dynamic-component-editor/mixins/dynamic-element-with-context-mixin";
import LinkUrlTemplate from "%/dynamic-component-editor/options/link-url-template";
import LayoutPositionOptions from "%/dynamic-component-editor/bundles/layout-position-options";
import SpacingOptions from "%/dynamic-component-editor/bundles/spacing-options";
import AppearanceOptions from "%/dynamic-component-editor/bundles/appearance-options";

export default {
  name: "LinkContainer",
  extends: Container,
  mixins: [DynamicElementWithContext],
  elementPanelSettings: {
    alias: "Link Container",
    displayName: "Link",
    displayIcon: "link",
    tags: ["container", "link", "navigate", "row"],
  },
  options: [
    LinkUrlTemplate,
  ],
  optionBundles: [
    new LayoutPositionOptions({
      "default.static-layout-direction": "vertical",
    }),
    SpacingOptions,
    new AppearanceOptions({}, {
      "border-radius": false,
    }),
  ],
};
</script>
